import {$hostAuth} from "../http";

class ConstructorService {
    async getProducts() {
        const {data} = await $hostAuth.get("/api/constructor/products");
        return data;
    }

    async updateProduct(id, data) {
        const {data: result} = await $hostAuth.patch(`/api/constructor/products/${id}`, data);
        return result;
    }

    async deleteProduct(id) {
        const {data} = await $hostAuth.delete(`/api/constructor/products/${id}`);
        return data;
    }

    async createGroup(productId, data) {
        const {data: result} = await $hostAuth.post(`/api/constructor/products/${productId}/groups`, data);
        return result;
    }

    async updateGroup(id, data) {
        const {data: result} = await $hostAuth.patch(`/api/constructor/groups/${id}`, data);
        return result;
    }

    async deleteGroup(id) {
        const {data} = await $hostAuth.delete(`/api/constructor/groups/${id}`);
        return data;
    }

    async createItem(groupId, data) {
        const {data: result} = await $hostAuth.post(`/api/constructor/groups/${groupId}/items`, data);
        return result;
    }

    async updateItem(id, data) {
        const {data: result} = await $hostAuth.patch(`/api/constructor/items/${id}`, data);
        return result;
    }

    async deleteItem(id) {
        const {data} = await $hostAuth.delete(`/api/constructor/items/${id}`);
        return data;
    }
}

export default new ConstructorService();
